<template>
  <div
    id="add-to-folder-modal"
    ref="modal-scroll-list"
    class="add-to-folder-modal"
    :class="{ loading: loading }"
  >
    <template v-if="loading">
      <svgicon
        class="modal-loader-icon"
        name="Misc/Loading-red-animated"
      />
      <div class="modal-content-loading" />
    </template>

    <div v-if="!noUserFolders && !loading">
      <div class="row-1_lg-3">
        <div
          v-for="(folder, i) in folders"
          :key="i"
          class="col-12_md-4"
        >
          <RecipeSavedCollectionLinkCard
            :title="folder.name"
            :recipe-count="folder.numberOfItems"
            block-size="third"
            class="add-to-folder-modal__collection-card"
            :dimensions="dimensions"
            :image-urls="folder.imageUrls"
            scroll-container-id="add-to-folder-modal"
            small-card-type
            @click.native.prevent="saveToFolder(folder.id)"
          />
        </div>
      </div>
      <div
        v-if="hasMoreFolders"
        class="row-center modal-load-more"
      >
        <svgicon
          class="modal-load-more__icon"
          name="Misc/Loading-red-animated"
        />
      </div>
    </div>
    <div class="add-to-folder-modal__button-container">
      <button
        class="button--48 button--text-icon"
        :class="{
          'button--fullwidth': $root.currentSizeLte('sm'),
        }"
        @click="createNewFolder()"
      >
        <svgicon
          name="Controls/Plus"
          aria-hidden="true"
        />
        Skapa ny receptsamling
      </button>
    </div>
  </div>
</template>

<script>
import RecipeSavedCollectionLinkCard from './RecipeSavedCollectionLinkCard'
import { infiniteScroll } from '../../../utils/helpers'
import { modalCardImgDimensions } from '../../../utils/imgDimensions'
import '#/Misc/Loading-red-animated'
import '#/Controls/Plus'
import svgicon from "vue-svgicon"

export default {
  name: 'AddSingleRecipeToFolderModal',
  components: {
    RecipeSavedCollectionLinkCard,
    svgicon,
  },
  props: {
    folders: {
      type: Array,
      default: () => []
    },
    totalFolderCount: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: true,
    },
    loadingMore: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      loadingMoreFolders: this.loadingMore,
      dimensions: modalCardImgDimensions,
    }
  },
  computed: {
    noUserFolders () {
      return !this.folders || this.folders.length === 0
    },
    hasMoreFolders () {
      return this.totalFolderCount > this.folders.length
    },
  },
  watch: {
    loadingMore (val) {
      this.loadingMoreFolders = val
    }
  },
  mounted () {
    const listElm = this.$refs['modal-scroll-list']
    listElm.addEventListener('scroll', this.infiniteScrollWrapper)
  },
  beforeDestroy () {
    const listElm = this.$refs['modal-scroll-list']
    listElm.removeEventListener('scroll', this.infiniteScrollWrapper)
  },
  methods: {
    infiniteScrollWrapper () {
      infiniteScroll(
        this.$refs['modal-scroll-list'],
        this.loadMore,
        !this.hasMoreFolders || this.loadingMoreFolders
      )
    },
    loadMore () {
      if (!this.loadingMoreFolders && !this.loading) {
        this.loadingMoreFolders = true
        this.$emit("load-more")
      }
    },
    createNewFolder () {
      this.$emit('create-new-folder')
    },
    saveToFolder (folderId) {
      // if folders
      if (this.totalFolderCount >= 1) {     
        this.$emit('save-to-folder', folderId)
      } else {
        this.$emit('create-new-folder')
      }
    },
  },
}
</script>

<style lang="scss">
.add-to-folder-modal {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding-right: 17px;
  box-sizing: content-box;
  padding-bottom: 5rem;
  padding-top: 1rem;

  @include media-breakpoint-up(md) {
    padding-top: 1.5rem;
  }

  &.loading {
    overflow: hidden;
  }

  &__collection-card {
    border-bottom: 1px solid $color-grey-light;
    padding-bottom: 1rem;

    @include media-breakpoint-up(md) {
      border: none;
      padding-bottom: 0;
    }
  }

  @include media-breakpoint-up(md) {
    max-height: 58vh;
    padding-bottom: 0;
  }

  &__button-container {
    border-top: 1px solid $color-grey-special;
    background: $color-white;
    padding: 1.5rem 0;
    position: fixed;
    bottom: 0;
    left: 1rem;
    right: 1rem;
    text-align: center;
    z-index: 3;

    @include media-breakpoint-up(md) {
      position: sticky;
      left: 0;
      right: 0;
      bottom: 0;
      padding: 1.5rem 0 0;
    }
  }
}

.create-folder {
  &__button-container {
    margin-top: 1.5rem;
    display: flex;
    justify-content: space-between;

    button:first-child {
      margin-right: 1rem;
    }
  }
}
</style>
